export const PROFILE = "EDIT PROFILE";
export const CUSTOMIZATIONS = "DISPLAY AND CUSTOMIZATION";
export const PAYMENTS = "PAYMENTS AND SUBSCRIPTION";
export const FEEDBACK = "FEEDBACK";
export const LOGOUT = "LOG OUT";
export const SETTINGS = "SETTINGS";
